var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonWalkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7209 2.13766C14.7209 3.31338 13.8 4.27533 12.6744 4.27533C11.5488 4.27533 10.6279 3.31338 10.6279 2.13766C10.6279 0.961949 11.5488 0 12.6744 0C13.8 0 14.7209 0.961949 14.7209 2.13766ZM6.02326 23.4899L8.88837 8.41941L7.04651 9.16759V12.8016H5V7.77811L10.3209 5.42668C10.4744 5.42668 10.6023 5.39996 10.7302 5.37324C10.8581 5.34651 10.986 5.31979 11.1395 5.31979C11.8558 5.31979 12.4698 5.74733 12.8791 6.38863L13.9023 8.09876C14.7209 9.59512 16.3581 10.664 18.3023 10.664V12.8016C16.0512 12.8016 14.0047 11.7328 12.6744 10.1295L12.0605 13.336L14.2093 15.4737V23.4899H12.1628V17.0769L10.014 14.9393L8.17209 23.4899H6.02326Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonWalkIcon);
export default __webpack_public_path__ + "static/media/PersonWalkIcon.73adb04d641ce637a49b2f581b9ac91f.svg";
export { ForwardRef as ReactComponent };